/* eslint-disable no-unused-vars */
/* eslint-disable no-case-declarations */
import defaults from "../defaults";

const GET_PROFILE_ALBUMS = "user/GET_PROFILE_ALBUMS";
const GET_PROFILE_ALBUMS_SUCCESS = "user/GET_PROFILE_ALBUMS_SUCCESS";
const GET_PROFILE_ALBUMS_FAIL = "user/GET_PROFILE_ALBUMS_FAIL";

const GET_PROFILE_ALBUM_GALLERIES = "user/GET_PROFILE_ALBUM_GALLERIES";
const GET_PROFILE_ALBUM_GALLERIES_SUCCESS =
	"user/GET_PROFILE_ALBUM_GALLERIES_SUCCESS";
const GET_PROFILE_ALBUM_GALLERIES_FAIL =
	"user/GET_PROFILE_ALBUM_GALLERIES_FAIL";

const GET_PROFILE_ALBUM_RELOAD = "user/GET_PROFILE_ALBUM_RELOAD";
const GET_PROFILE_ALBUM_RELOAD_SUCCESS =
	"user/GET_PROFILE_ALBUM_RELOAD_SUCCESS";
const GET_PROFILE_ALBUM_RELOAD_FAIL = "user/GET_PROFILE_ALBUM_RELOAD_FAIL";

const SET_USER_SUSPENSION = "user/SET_USER_SUSPENSION";

const initialState = defaults.user;

export default function reducer(state = initialState, action = {}) {
	switch (action.type) {
		case GET_PROFILE_ALBUMS:
			return {
				...state,
				galleries: {
					...state.galleries,
					albums_list: {
						...state.galleries.albums_list,
						loading: true,
						data: [],
					},
				},
			};
		case GET_PROFILE_ALBUMS_SUCCESS:
			if (!action.result.data) {
				return {
					...state,
					galleries: {
						...state.galleries,
						albums_list: {
							...state.galleries.albums_list,
							loaded: true,
							loading: false,
						},
					},
				};
			}
			return {
				...state,
				galleries: {
					...state.galleries,
					albums_list: {
						loading: false,
						loaded: true,
						data: action.result.data ?? [],
					},
				},
			};
		case GET_PROFILE_ALBUMS_FAIL:
			return {
				...state,
				images: {
					...state.images,
					albums_list: {
						...state.images.albums_list,
						loading: false,
					},
				},
			};
		// ** Get Profile Album Images
		case GET_PROFILE_ALBUM_GALLERIES:
			if (action.reset) {
				return {
					...state,
					galleries: {
						...state.galleries,
						current_album: {
							...state.galleries.current_album,
							loading: true,
							[action.albumId]: {
								total: 0,
								photos:
									state.galleries.current_album[
										action.albumId
									]?.photos ?? 0,
								videos:
									state.galleries.current_album[
										action.albumId
									]?.videos ?? 0,
								hash: [],
								data: [],
								pagination: {
									totalPages: 1,
									currentPage: 1,
								},
							},
						},
					},
				};
			}
			return {
				...state,
				galleries: {
					...state.galleries,
					current_album: {
						...state.galleries.current_album,
						loading: true,
					},
				},
			};
		case GET_PROFILE_ALBUM_GALLERIES_SUCCESS:
			const dataResult = action.reset
				? [...(action.result.data?.media ?? [])]
				: [
						...(state.galleries.current_album[action.albumId]
							?.data ?? []),
						...(action.result.data?.media ?? []),
				  ];

			return {
				...state,
				galleries: {
					...state.galleries,
					current_album: {
						...state.galleries.current_album,
						loading: false,
						name: action.result.data?.media_album?.album_name,
						isPrivate:
							action.result.data?.media_album?.album_private,
						[action.albumId]: {
							total: action.result.data?.total,
							photos: action.result.data?.photos,
							videos: action.result.data?.videos,
							hash: action.result.data?.hash,
							data: action.reset
								? dataResult
								: dataResult.filter((val, id) => {
										return (
											id ===
											dataResult.findIndex(
												(el) => el.id === val.id
											)
										);
								  }),
							pagination: {
								totalPages:
									action.result.data?.pagination.totalpages ??
									1,
								currentPage:
									action.result.data?.pagination
										.currentpage ?? 1,
							},
						},
					},
				},
			};
		case GET_PROFILE_ALBUM_GALLERIES_FAIL:
			return {
				...state,
				galleries: {
					...state.galleries,
					current_album: {
						...state.galleries.current_album,
						loading: false,
					},
				},
			};

		// ** Get Profile Album Reload
		case GET_PROFILE_ALBUM_RELOAD:
			return {
				...state,
				galleries: {
					...state.galleries,
					current_album: {
						...state.galleries.current_album,
						loading: true,
						[action.albumId]: {
							total: 0,
							data: [],
							pagination: {
								totalPages: 1,
								currentPage: 1,
							},
						},
					},
				},
			};
		case GET_PROFILE_ALBUM_RELOAD_SUCCESS:
			return {
				...state,
				galleries: {
					...state.galleries,
					current_album: {
						...state.galleries.current_album,
						loading: false,
						[action.albumId]: {
							total: action.result.data?.total,
							hash: action.result.data?.hash,
							data: [...(action.result.data?.media ?? [])],
							pagination: {
								totalPages:
									action.result.data?.pagination.totalpages ??
									1,
								currentPage:
									action.result.data?.pagination
										.currentpage ?? 1,
							},
						},
					},
				},
			};
		case GET_PROFILE_ALBUM_RELOAD_FAIL:
			return {
				...state,
				galleries: {
					...state.galleries,
					current_album: {
						...state.galleries.current_album,
						loading: false,
					},
				},
			};

		case SET_USER_SUSPENSION: {
			return {
				...state,
				suspension: action.suspension,
			};
		}

		default:
			return state;
	}
}

export function getProfileAlbums(id, isAuth, showPrivateMedia = null) {
	return {
		types: [
			GET_PROFILE_ALBUMS,
			GET_PROFILE_ALBUMS_SUCCESS,
			GET_PROFILE_ALBUMS_FAIL,
		],
		promise: (client) =>
			client.get(`/album${isAuth ? "" : "/unauthorized"}/all`, {
				params: {
					user: id,
					withMedia: true,
					showMedia: isAuth ? showPrivateMedia : null,
				},
			}),
	};
}

export function getProfileAlbumGalleries(
	albumId,
	userId,
	page = 1,
	hash,
	isAuth,
	sort = "any",
	reset = false
) {
	return {
		types: [
			GET_PROFILE_ALBUM_GALLERIES,
			GET_PROFILE_ALBUM_GALLERIES_SUCCESS,
			GET_PROFILE_ALBUM_GALLERIES_FAIL,
		],
		promise: (client) =>
			client.get(`/media/album${isAuth ? "" : "/unauthorized"}`, {
				params: {
					id: albumId,
					user: userId,
					page,
					hash,
					sort,
				},
			}),
		withToastInterval: true,
		albumId,
		reset,
	};
}

export function setUserSuspension(to, code) {
	return {
		type: SET_USER_SUSPENSION,
		suspension: {
			duration: Math.floor(to - Date.now() / 1000),
			to,
			code,
		},
	};
}

export function clearUserSuspension() {
	return {
		type: SET_USER_SUSPENSION,
		suspension: {
			duration: 0,
			to: -1,
			code: -1,
		},
	};
}
